import {
  DynamicComponentResolveFunction,
  FormRenderingService,
} from '@alfresco/adf-core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WkFormRenderingService {
  constructor(private readonly formRenderingService: FormRenderingService) {}

  public setComponentTypeResolver(
    type: string,
    resolver: DynamicComponentResolveFunction,
    overridde = false
  ): void {
    this.formRenderingService.setComponentTypeResolver(
      type,
      resolver,
      overridde
    );
  }
}
